import React from 'react';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { ResponseError } from '../../../common/pokCore/autogenerated/pokApiClient';
import { responseErrors } from '../../../common/pokCore/validation/responseErrors';
import { useTranslation } from '../../../common/hooks/useTranslation';
import ConfirmationButton from '../../../app/components/ConfirmationButton';
import AlertModal from '../../../app/components/AlertModal';

interface RepeatClientSurveyButtonProps {
  id: string;
  onRefresh: () => void;
}

export const RepeatClientSurveyButton: React.FC<
  RepeatClientSurveyButtonProps
> = ({ id, onRefresh }) => {
  const pok = usePokCore();
  const [showInfo, setShowInfo] = React.useState(false);
  const [info, setInfo] = React.useState('');
  const [success, setSuccess] = React.useState(false);
  const { t, tk } = useTranslation('administrationLng');

  return (
    <>
      <span
        role="presentation"
        onClick={e => e.stopPropagation()}
        onKeyDown={e => e.stopPropagation()}
      >
        <ConfirmationButton
          variant="outline-secondary"
          confirmation={t(tk.clientSurvey.repeatConfirmation)}
          onOK={async () => {
            try {
              await pok.clientSurveys.repeatClientSurvey(id);
              setInfo(t(tk.clientSurvey.repeatSuccess));
              setSuccess(true);
              setShowInfo(true);
              onRefresh();
            } catch (err) {
              const errors = await responseErrors(err as ResponseError);
              setInfo(t(tk.clientSurvey.repeatError) + ' ' + (errors[0] || ''));
              setSuccess(false);
              setShowInfo(true);
            }
          }}
        >
          {t(tk.clientSurvey.repeat)}
        </ConfirmationButton>
      </span>
      <AlertModal
        variant={success ? 'info' : 'danger'}
        buttonText={t(tk.button.close)}
        buttonVariant={'outline-success'}
        size="lg"
        show={showInfo}
        onHide={() => {
          setShowInfo(false);
        }}
      >
        {info}
      </AlertModal>
    </>
  );
};
